// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as actions from './actions';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as t from './tracking';

export default function({ getState }) {
  return next => action => {
    const state = getState();
    switch (action.type) {
      case actions.SAVE_CART_SUCCESS:
        t.cartContentsChanged(state.currentOrder, action.order, state);
        break;
      case actions.CHANGE_ORDER_MEMBERSHIP:
        t.orderMembershipStatusChanged(action.value, action.eventLocation);
        break;
      case actions.CHANGE_QUICK_SHOP_MODAL_VISIBILITY:
        t.quickShopModalVisibilityChanged(action.value, action.variants, state);
        break;
      case actions.CHANGE_QUICK_SHOP_SELECTED_VARIANT:
        t.quickShopVariantChanged(action.variant, state);
        break;
      case actions.CONVERT_ORDER_TO_SUBSCRIPTION:
        t.convertToSubscription(action.order, state);
        break;
    }
    return next(action);
  };
}
